import React, { Component } from "react";
export const userJourneyContext = React.createContext();

class userJourneyContextProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      children: props.children,
      app_tour_state: { index: 0, type: "" },
      selectedMenu: {},
      setAppTourState: this.setAppTourState,
      userJourneyInfo: {
        name: "",
        email: "",
        role: "",
        action: 'user_journey',
        payload: {
          title: 'Start Tour',
          steps: 1
        }
      },
      setUserJourneyInfo: this.setUserJourneyInfo,
      openTooltipNotification: false,
      setOpenTooltipNotification: this.setOpenTooltipNotification,
      openGlobalRiskTooltip: false,
      setOpenGlobalRiskTooltip: this.setOpenGlobalRiskTooltip,
      userJourneyProgress: 0,
      setUserJourneyProgress: this.setUserJourneyProgress
    };
  }

  setAppTourState = (app_tour_state) => {
    this.setState({ app_tour_state });
  };

  setSelectedMenu = (selectedMenu) => {
    this.setState({ selectedMenu });
  };

  setUserJourneyInfo = (user_journey) => {
    console.log("appContext ", user_journey)
    this.setState((prevState) => ({ user_journey }));
  }

  setOpenTooltipNotification = (isOpen) => {
    console.log("isOpen ", isOpen);
    this.setState((prevState) => ({ isOpen }));
  }

  setOpenGlobalRiskTooltip = (isOpen) => {
    console.log("isOpen ", isOpen);
    this.setState((prevState) => ({ isOpen }));
  }

  setUserJourneyProgress = (value) => {
    console.log("value  ", value);
    this.setState((prevState) => ({ value }));
  }
  

  render() {
    return (
      <userJourneyContext.Provider value={this.state}>
        {this.state.children}
      </userJourneyContext.Provider>
    );
  }
}

export default userJourneyContextProvider;
